
import api from '@/api/api';
import Request from '@/utils/request';
const { request, baseURL } = Request;
var $http = request;

import wx from 'weixin-js-sdk';
var $wx = wx;
export default {


  //直接回到页面顶部
  toPageTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },


  //根据登录状态获取token uid
  getToken() {
    var isRemember = localStorage.getItem('isRemember') || false;//是否记住登录状态
    var bh_token = '';
    var bh_uid = '';
    if (isRemember) {
      bh_token = localStorage.getItem('by_token') || '';
      bh_uid = localStorage.getItem('by_uid') || '';

      if (this.isEmpty(bh_token)) {
        bh_token = sessionStorage.getItem('by_token') || '';
      }
      if (this.isEmpty(bh_uid)) {
        bh_uid = sessionStorage.getItem('by_uid') || '';
      }
    } else {
      bh_token = sessionStorage.getItem('by_token') || '';
      bh_uid = sessionStorage.getItem('by_uid') || '';
    }
    return {token: bh_token, uid: bh_uid};
  },


  shareConfig(wx, share_href, data, share_icon){


    // share_href = share_href.replace('/#/', '/?#/');

    wx.ready(function () {

      //分享到朋友圈
      wx.onMenuShareTimeline({
        title: data.title, // 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name, // 分享时的简介
        success: function (res) {
          console.log("onMenuShareTimeline-success", res)
        },
        cancel: function (error) {
          console.log("onMenuShareTimeline-error", error)
        }
      });


      //分享给朋友
      wx.onMenuShareAppMessage({
        title: data.title,// 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name,// 分享时的简介
        type: 'link',
        dataUrl: '',
        success: function (res) {
          console.log("onMenuShareAppMessage-success", res)
        },
        cancel: function (error) {
          console.log("onMenuShareAppMessage-error", error)
        }
      });

      //分享到朋友圈
      wx.updateTimelineShareData({
        title: data.title, // 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name, // 分享时的简介
        success: function (res) {
          console.log("updateTimelineShareData-success", res)
        },
        cancel: function (error) {
          console.log("updateTimelineShareData-error", error)
        }
      });


      //分享给朋友
      wx.updateAppMessageShareData({
        title: data.title,// 分享时的标题
        link: share_href, // 分享时的链接
        imgUrl: share_icon, // 分享时的图标
        desc: data.type_name,// 分享时的简介
        success: function (res) {
          console.log("updateAppMessageShareData-success", res)
        },
        cancel: function (error) {
          console.log("updateAppMessageShareData-error", error)
        }
      });

    })
  },


  //隐藏手机号中间四位
  hideMobile(tel){
    var reg = /^(\d{3})\d{4}(\d{4})$/;
    return tel.replace(reg, "$1****$2");
  },

  //判断是否为空
  isEmpty(val) {
    if (val == "" || val == null || val == undefined || val == " ")
      return true;
    return false;
  },
  //倒计时
  countDown(obj, num) {
    if (num == 1) {
      var Timer = setInterval(() => {
        if (obj.code_time > 0) {
          obj.code_time--;
          obj.code_text = `${obj.code_time}秒后获取`;
          obj.code_flag = false;
        } else {
          obj.code_flag = true;
          obj.code_time = 60;
          obj.code_text = `重新获取`;
          clearInterval(Timer);
        }
      }, 1000)
    } else {
      var Timer = setInterval(() => {
        if (obj.re_code_time > 0) {
          obj.re_code_time--;
          obj.re_code_text = `${obj.re_code_time}秒后获取`;
          obj.re_code_flag = false;
        } else {
          obj.re_code_flag = true;
          obj.re_code_time = 60;
          obj.re_code_text = `重新获取`;
          clearInterval(Timer);
        }
      }, 1000)
    }

  },


  //判断是否登录
  isLogin(type) {
    var by_uid = localStorage.getItem("by_uid") || '';
    var by_token = localStorage.getItem("by_token") || '';
    if(by_uid == '' || by_token == ''){
      if(type == 1){
        window.location.href = '/';
      }else if(type == 2){
        // let local = window.location.href.split("#")[0];
        // window.location.href = local + '/#/member';

        let local = window.location.href.split("?")[0];
        window.location.href = local + '/member';
      }
    }
  },

  /* 是否手机号码*/
  isMobile(value) {
    const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    if (value == '' || value == undefined || value == null) {
      return false;
    } else {
      if (!reg.test(value)) {
        return false;
      } else {
        return true;
      }
    }
  },


  //时间戳  转 年月日
  add0(m) {
    return m < 10 ? '0' + m : m
  },
  format(timestamp, type) {
    //timestamp是整数，否则要parseInt转换
    var time = new Date(timestamp);
    var y = time.getFullYear();
    var m = time.getMonth() + 1;
    var d = time.getDate();
    var h = time.getHours();
    var mm = time.getMinutes();
    var s = time.getSeconds();
    if (type == 'yyyy-mm-dd') {
      return y + '.' + this.add0(m) + '.' + this.add0(d);
    } else if (type == 'mm-dd') {
      return this.add0(m) + '.' + this.add0(d);
    } else if (type == 'yyyy-mm-dd/hh:mm:ss') {
      return y + '.' + this.add0(m) + '.' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
    }
  },

  //获取链接上参数
  getParam(variable) {
    var query = window.location.search.substring(1);
    var query3 = window.location.href.split("?");
    query = query + '&' + query3[1] + '&' + query3[2];
    console.log("param：" + query);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return (false);
  },


  //判断是否为ios
  isIOS() {
    var isIphone = navigator.userAgent.includes('iPhone');
    var isIpad = navigator.userAgent.includes('iPad');
    return isIphone || isIpad;
  },


  //获取code
  getAuthInfo(callback){
    var that = this;
    var by_uid = localStorage.getItem("by_uid") || '';
    var by_token = localStorage.getItem("by_token") || '';

    if(by_uid == '' || by_token == ''){
      let code = that.getParam("code");
      if (!code) {
        // let local = window.location.href.split("#")[0];
        // let local = window.location.href.split("?")[0];
        let local = window.location.href;
        var param = {
          return_url: local,
        }
        $http(api.wx_code_url, param, '获取code').then(res =>{
          if(res.code == 200){
            window.location.href = res.data;
          }
        });
      } else {
        console.log("code", that.getParam("code"));
        var param = {
          code: that.getParam("code"),
        }
        $http(api.wx_userinfo, param, '获取code').then(res =>{
          if(res.code == 200){
            var data = res.data;
            if(data.userinfo){
              that.wxLogin(data.userinfo, callback);
            }
          }else{
            that.$toast(res.msg);
          }
        });
      }
    }
  },

  //微信登录
  wxLogin(info, callback){
    var that = this;
    var param = {
      wx_openid: info.openid,
      nickname: info.nickname,
      wx_headimg: info.headimgurl,
      unionid: info.unionid,
    }
    $http(api.gzh_login, param, '微信登录').then(res =>{
      if(res.code == 200){
        var data = res.data;
        localStorage.setItem('by_uid', data.uid || data.id);
        localStorage.setItem('by_token', data.token);
        localStorage.setItem('by_unionid', data.unionid);
        localStorage.setItem('by_openid', info.openid);
        if(callback){
          callback();
        }
      }else{
        that.$toast(res.msg);
      }
    });
  },


  //获取微信签名
  getWxSign(){
    var that = this;
    let local = window.location.href.split("#")[0];
    var param = {
      reqUrl: local,
    }
    $http(api.getSignPackage, param, '获取微信签名').then(res =>{
      if(res.code == 200){
        var config = res.data;
        $wx.config({ // eslint-disable-line
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
          appId: config.appId, // 必填，公众号的唯一标识
          timestamp: config.timestamp, // 必填，生成签名的时间戳
          nonceStr: config.nonceStr, // 必填，生成签名的随机串
          signature: config.signature,// 必填，签名
          jsApiList: ['onMenuShareTimeline','checkJsApi', 'chooseWXPay'], // 必填，需要使用的JS接口列表
          openTagList: ['wx-open-launch-weapp'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
        });
        /* eslint-disable */
        $wx.ready(function () {
          console.log('ready')
        });
        $wx.error(function (res) {
          console.log(res)
        });
      }
    });
  },


}



// WEBPACK FOOTER //
// ./src/utils/utils.js